import { useEffect, useState } from "react";
import {
  useForm,
  observer,
  useFieldSchema,
  RecursionField,
} from "@formily/react";
import { IRumbleFormScope } from ".";
import { useStateMachine } from "little-state-machine";
import { isMediaIntent } from "@rumble-it/common-lib/src/helpers/mediaIntent";

export const InsuranceCard = observer((props: any) => {
  const { state } = useStateMachine();
  const [insuranceCardValue, setInsuranceCardValue] = useState(null);

  const form = useForm();
  const schema = useFieldSchema();
  const scope = (state as { scope?: IRumbleFormScope }).scope;
  const fetchData = scope?.fetchData;
  if (!fetchData) {
    throw new Error("fetchData function is not available");
  }

  const dossier = form.getValuesIn("dossier");
  if (!dossier) {
    return null;
  }

  const hasRequiredInsuranceCard =
    dossier?.mediaUsages?.some((mediaUsage: any) =>
      isMediaIntent(mediaUsage.intent, "insurance_card"),
    ) ?? false;

  const hasIntentInImageCapture = (dossier: any, intentName: string) =>
    dossier?.imageCaptureSents?.some((sent: any) =>
      sent?.imageCaptureMedia?.some((fileUsage: any) =>
        isMediaIntent(fileUsage.intent, intentName),
      ),
    ) ?? false;
  const hasInsuranceCardInImageCapture = hasIntentInImageCapture(
    dossier,
    "insurance_card",
  );

  const needRequiredInsuranceCard =
    hasRequiredInsuranceCard === false &&
    hasInsuranceCardInImageCapture === false
      ? true
      : false;

  if (!needRequiredInsuranceCard) {
    return null;
  }

  const patchInsuranceCard = async (media: any) => {
    try {
      const response = await fetchData({
        endpoint: `${props.patchEndpoint ?? `/dossiers/repair-direct/generic`}/${dossier.id}`,
        method: "PATCH",
        headers: {
          Accept: "application/ld+json",
          "Content-Type": "application/merge-patch+json",
        },
        data: {
          insuranceCard: media?.mediaIri,
        },
      });

      if (response.data) {
        window.location.reload();
      }
    } catch (err) {
      console.error("Fetch failed:", err);
    }
  };

  useEffect(() => {
    if (insuranceCardValue) {
      patchInsuranceCard(insuranceCardValue);
    }
  }, [insuranceCardValue]);

  form.getFieldState("insuranceCard", (field) => {
    if (field?.value != insuranceCardValue) {
      setInsuranceCardValue(field?.value);
    }
  });

  return (
    <>
      {schema?.mapProperties
        ? schema.mapProperties((schema, name) => {
            return <RecursionField key={name} name={name} schema={schema} />;
          })
        : null}
    </>
  );
});
